<template>
  <div class="redemption-code-box">
    <!-- 操作栏 -->
    <div class="action-bar">
      <el-select
        v-model="params.status"
        size="small"
        clearable
        placeholder="请选择是否有效"
      >
        <el-option
          v-for="item in enables"
          :value="item.value"
          :label="item.label"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-button
        type="primary"
        size="small"
        @click="redemptionPrizeList('status')"
        >搜索</el-button
      >
      <el-button type="primary" size="small" @click="prizeAction('add')"
        >+新增兑换奖品</el-button
      >
    </div>
    <!-- 表格数据 -->
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      max-height="600"
    >
      <el-table-column
        prop="prizes"
        label="奖品"
        align="center"
        min-width="200"
        :formatter="formatterPrize"
      ></el-table-column>
      <el-table-column
        prop="point"
        label="消耗积分数"
        align="center"
        min-width="200"
      >
        <template slot-scope="scope">
          <span> {{ scope.row.point }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="是否有效"
        align="center"
        min-width="120"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == 1">有效</el-tag>
          <el-tag type="error" v-else-if="scope.row.status == 0">无效</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="sort"
        label="奖品排序"
        align="center"
        min-width="200"
      ></el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="220"
      >
        <template slot-scope="scope">
          <span> {{ scope.row.createTimt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="更新时间"
        align="center"
        min-width="220"
      >
        <template slot-scope="scope">
          <span> {{ scope.row.updateTime | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="operating"
        label="操作"
        align="center"
        fixed="right"
        width="150"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="prizeAction('edit', scope.row)"
          ></el-button>
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="del(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[5, 10, 15, 20]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      @size-change="changeSize"
      :total="total"
      v-if="total > 10"
      @current-change="changeCurrent"
    ></el-pagination>
    <!--新增、编辑tag弹窗-->
    <prize-action
      ref="prizeAction"
      :prizeBox="prizeBox"
      @handlerCodeList="handlerCodeList"
    ></prize-action>
  </div>
</template>
<script>
import prizeAction from "./components/prizeAction";
import { paramsFilter } from "@/utils/global";
import baseConfig from "@/utils/serverUrlConfig";
import API from "@/api";
export default {
  components: {
    prizeAction,
  },
  data() {
    return {
      tableData: [],
      loading: false,
      total: "",
      // 奖品列表参数
      params: {
        activityId: "",
        type: "",
        status: "",
        pageNumber: 1,
        pageSize: 10,
      },
      prizeBox: [],
      imgUrl: baseConfig.imgUrl,
      actIDs: [],
      vipCardIds: [],
      enables: [
        { label: "无效", value: 0 },
        { label: "有效", value: 1 },
      ],
      levels: [
        { label: "初级", value: 1 },
        { label: "中级", value: 2 },
        { label: "高级", value: 3 },
      ],
      priceType: [
        { label: "活跃值", value: 1 },
        { label: "金币", value: 2 },
        { label: "棋牌金币", value: 3 },
        { label: "楼风解锁折扣券", value: 4 },
        { label: "会员卡", value: 5 },
        { label: "会员折扣券", value: 6 },
        { label: "实物", value: 7 },
        { label: "ai脱衣免费次数", value: 8 },
        { label: "ai换脸抵扣券", value: 9 },
        { label: "金币视频观影券", value: 10 },
        { label: "积分", value: 11 },
      ],
    };
  },
  filters: {
    // 是否激活
    isActive(val) {
      switch (val) {
        case false:
          return "未激活";
        case true:
          return "激活";
        default:
          return "未知";
      }
    },
  },
  created() {
    this.queryPrizeBox();
    // this.getActiveityId();
    // this.getVipcardId();
  },
  methods: {
    queryPrizeBox() {
      API.queryPrizeBox()
        .then((res) => {
          this.redemptionPrizeList();
          if (res.code === 200 && res.data.length > 0) {
            this.prizeBox = res.data;
            return;
          }
          this.$message.error(res.msg || "获取奖品失败");
          this.prizeBox = [];
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 获取活动ID
    // getActiveityId() {
    //   API.getActiveityId(this.params).then((res) => {
    //     if (res.code === 200 && res.data) {
    //       this.actIDs = res.data;
    //       return;
    //     }
    //     this.$message.error("获取活动失败");
    //   });
    // },
    // 获取VIP ID
    // getVipcardId() {
    //   API.getVipcardId(this.params).then((res) => {
    //     if (res.code === 200 && res.data) {
    //       this.vipCardIds = res.data;
    //       return;
    //     }
    //     this.$message.error("获取会员卡失败");
    //   });
    // },
    del(row) {
      this.$confirm(`确认是否删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          let delData = {
            id: row.id,
          };
          API.delPointsPrice(delData)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.redemptionPrizeList();
              } else {
                this.$message({
                  type: "success",
                  message: "删除失败!",
                });
              }
              // this.getModules();
            })
            .catch(() => {
              this.$message({
                type: "error",
                message: "服务器异常!",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 请求兑换码列表
    redemptionPrizeList() {
      this.loading = true;
      let formData = paramsFilter(this.params);
      API.getPointsPrice(formData)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.count;
          } else {
            this.tableData = [];
            this.total = 0;
            this.$message.error(res.tip || "获取数据失败");
          }
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    formatterLevel(level) {
      return this.levels.filter((item) => item.value == level).length > 0
        ? this.levels.filter((item) => item.value == level)[0].label
        : "未知";
    },
    formatterPriceType(type) {
      return this.priceType.filter((item) => item.value == type).length > 0
        ? this.priceType.filter((item) => item.value == type)[0].label
        : "未知";
    },
    formatterPrize(row) {
      var htmlStr = "";
      // console.log(row.prize);
      if (
        this.prizeBox.length === 0 ||
        !row.prize ||
        (row.prize && row.prize.length === 0)
      ) {
        return "获取奖品列表失败";
      }
      // if (row.prize && row.prize.length) {
      this.prizeBox.forEach((data) => {
        row.prize.forEach((value) => {
          if (data.value == value) {
            htmlStr += "、" + data.label;
          }
        });
      });
      // }

      htmlStr = htmlStr.substr(1, htmlStr.length);
      return htmlStr;
    },
    formatterAct(id) {
      return this.actIDs.filter((item) => item.value == id).length > 0
        ? this.actIDs.filter((item) => item.value == id)[0].label
        : "未知";
    },
    formatterVip(id) {
      return this.vipCardIds.filter((item) => item.value == id).length > 0
        ? this.vipCardIds.filter((item) => item.value == id)[0].label
        : "未知";
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size;
      this.params.pageNumber = 1;
      this.redemptionPrizeList();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.redemptionPrizeList();
    },
    // 编辑活动成功回掉
    handlerCodeList() {
      this.redemptionPrizeList();
    },
    // 新增、删除tags
    prizeAction(type, data) {
      this.$refs.prizeAction.open(type, data);
    },
  },
};
</script>
<style scoped></style>
